import { ReactNode } from 'react';
import ReactTooltip, { Place } from 'react-tooltip';

export interface ITooltipProps {
	id: string;
	content: ReactNode;
	iconName?: string;
	place?: Place;
	children?: ReactNode
}

export function Tooltip(props: ITooltipProps) {

	const {
		id,
		content,
		iconName,
		place = 'bottom',
		children
	} = props;

	const finalIcon = iconName ? `icon-${iconName}` : "icon-information-2";
	const iconClass = children ? "" : `${finalIcon} icon-right`;

	return (
		<>
			<span
				className={`tooltip ${iconClass}`}
				data-for={id}
				data-tip={content}
			>
				{children}
			</span>

			<ReactTooltip
				id={id}
				place={place}
				effect="solid"
				className="tooltip-box"
			>
				{content}
			</ReactTooltip>
		</>
	);
}
